/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvestmentInfo } from './InvestmentInfo';
import {
    InvestmentInfoFromJSON,
    InvestmentInfoFromJSONTyped,
    InvestmentInfoToJSON,
} from './InvestmentInfo';

/**
 * 
 * @export
 * @interface ClientInvestmentInfoViewModel
 */
export interface ClientInvestmentInfoViewModel {
    /**
     * 
     * @type {string}
     * @memberof ClientInvestmentInfoViewModel
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInvestmentInfoViewModel
     */
    clientName: string;
    /**
     * 
     * @type {Array<InvestmentInfo>}
     * @memberof ClientInvestmentInfoViewModel
     */
    investments: Array<InvestmentInfo>;
}

/**
 * Check if a given object implements the ClientInvestmentInfoViewModel interface.
 */
export function instanceOfClientInvestmentInfoViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientId" in value;
    isInstance = isInstance && "clientName" in value;
    isInstance = isInstance && "investments" in value;

    return isInstance;
}

export function ClientInvestmentInfoViewModelFromJSON(json: any): ClientInvestmentInfoViewModel {
    return ClientInvestmentInfoViewModelFromJSONTyped(json, false);
}

export function ClientInvestmentInfoViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientInvestmentInfoViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientId': json['ClientId'],
        'clientName': json['ClientName'],
        'investments': ((json['Investments'] as Array<any>).map(InvestmentInfoFromJSON)),
    };
}

export function ClientInvestmentInfoViewModelToJSON(value?: ClientInvestmentInfoViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ClientId': value.clientId,
        'ClientName': value.clientName,
        'Investments': ((value.investments as Array<any>).map(InvestmentInfoToJSON)),
    };
}

